import { FC } from 'react';
// components
import AccessDenied from 'components/AccessDenied';
// helper, interfaces, context
import { isSuperAdmin } from 'lib/helper';
import { ChildrenType } from 'interfaces';
import { useAuthContext } from 'contexts/AuthContext';

export const SuperAdminGuard: FC<ChildrenType> = ({ children }) => {
  const { userRoles } = useAuthContext();

  const isSuper = isSuperAdmin(userRoles);

  return <>{isSuper ? children : <AccessDenied />}</>;
};
